var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9425 2.6538C16.3782 1.78206 17.6218 1.78207 18.0575 2.65381L20.8737 8.28832C21.2667 9.07473 20.6951 10 19.8162 10H19.4128L21.8421 14.8604C22.3334 15.8434 21.6188 17 20.5202 17H17.75V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H5.25V18H3.18382C2.30492 18 1.73329 17.0747 2.12634 16.2883L3.77343 12.9929C3.18051 12.9183 2.8174 12.2712 3.09476 11.7162L5.20689 7.49035C5.53367 6.83655 6.46633 6.83655 6.79311 7.49035L8.90524 11.7162C9.1826 12.2712 8.81949 12.9183 8.22657 12.9929L9.87366 16.2883C10.2667 17.0747 9.69508 18 8.81618 18H6.75V21.25H16.25V17H13.4798C12.3812 17 11.6666 15.8434 12.1579 14.8604L14.5872 10H14.1838C13.3049 10 12.7333 9.07472 13.1263 8.28832L15.9425 2.6538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesAlt);
export default __webpack_public_path__ + "static/media/trees-alt.8bafb83d1f837e714f6a4ebb2c4901f8.svg";
export { ForwardRef as ReactComponent };